export default __webpack_public_path__ + "static/media/movie.67797e94.png";